
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const LocationArrowIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_13527_102276)">
<path fillRule="evenodd" clipRule="evenodd" d="M74.0052 15.3324C78.1298 13.9283 82.0711 17.8696 80.667 21.9942L59.4519 84.3134C57.8425 89.041 51.164 89.0631 49.5234 84.3462L39.7504 56.2489L11.6531 46.476C6.93632 44.8353 6.95837 38.1569 11.686 36.5475L74.0052 15.3324ZM72.8943 23.1051L18.7559 41.5352L42.8498 49.9156C44.3654 50.4428 45.5566 51.634 46.0837 53.1495L54.4642 77.2434L72.8943 23.1051Z" fill="#161617"/>
</g>
<defs>
<clipPath id="clip0_13527_102276">
<rect width="96" height="96" fill="white"/>
</clipPath>
</defs>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_13527_103091)">
<path d="M75.1333 18.6468C76.5082 18.1788 77.8219 19.4925 77.3539 20.8674L56.1388 83.1866C55.6024 84.7625 53.3762 84.7698 52.8293 83.1975L42.7782 54.3005C42.6025 53.7953 42.2054 53.3982 41.7002 53.2225L12.8032 43.1714C11.2309 42.6245 11.2382 40.3983 12.8141 39.8619L75.1333 18.6468Z" fill="#F2F2F3"/>
</g>
<defs>
<clipPath id="clip0_13527_103091">
<rect width="96" height="96" fill="white"/>
</clipPath>
</defs>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_13527_102276)">
<path fillRule="evenodd" clipRule="evenodd" d="M74.0052 15.3324C78.1298 13.9283 82.0711 17.8696 80.667 21.9942L59.4519 84.3134C57.8425 89.041 51.164 89.0631 49.5234 84.3462L39.7504 56.2489L11.6531 46.476C6.93632 44.8353 6.95837 38.1569 11.686 36.5475L74.0052 15.3324ZM72.8943 23.1051L18.7559 41.5352L42.8498 49.9156C44.3654 50.4428 45.5566 51.634 46.0837 53.1495L54.4642 77.2434L72.8943 23.1051Z" fill="#161617"/>
</g>
<defs>
<clipPath id="clip0_13527_102276">
<rect width="96" height="96" fill="white"/>
</clipPath>
</defs>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_13527_103091)">
<path d="M75.1333 18.6468C76.5082 18.1788 77.8219 19.4925 77.3539 20.8674L56.1388 83.1866C55.6024 84.7625 53.3762 84.7698 52.8293 83.1975L42.7782 54.3005C42.6025 53.7953 42.2054 53.3982 41.7002 53.2225L12.8032 43.1714C11.2309 42.6245 11.2382 40.3983 12.8141 39.8619L75.1333 18.6468Z" fill="#F2F2F3"/>
</g>
<defs>
<clipPath id="clip0_13527_103091">
<rect width="96" height="96" fill="white"/>
</clipPath>
</defs>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
